import {
  ParcelSchema,
  type IParcel,
} from "@redotech/redo-model/outbound-labels/parcel";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const upsertParcels = {
  name: "upsertParcels" as const,
  input: z.object({ parcels: z.array(ParcelSchema as IParcel) }),
  output: zNull(),
};
